/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTeamRequest
 */
export interface UpdateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTeamRequest
     */
    client_id: number;
}

/**
 * Check if a given object implements the UpdateTeamRequest interface.
 */
export function instanceOfUpdateTeamRequest(value: object): value is UpdateTeamRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    return true;
}

export function UpdateTeamRequestFromJSON(json: any): UpdateTeamRequest {
    return UpdateTeamRequestFromJSONTyped(json, false);
}

export function UpdateTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'client_id': json['client_id'],
    };
}

export function UpdateTeamRequestToJSON(json: any): UpdateTeamRequest {
    return UpdateTeamRequestToJSONTyped(json, false);
}

export function UpdateTeamRequestToJSONTyped(value?: UpdateTeamRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'client_id': value['client_id'],
    };
}

